var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptimize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "nmf1cytyca",
    d: "M0 0h14v14H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "os0cbs42cb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nmf1cytyca"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.855 10.833 14 11.978h-3.111V8.867l1.062 1.062a5.757 5.757 0 0 0-6.37-8.51L5.276.214a7.003 7.003 0 0 1 7.579 10.62zM8.419 12.58l.304 1.207a7.006 7.006 0 0 1-7.58-10.62L0 2.021h3.111v3.112L2.047 4.069a5.759 5.759 0 0 0 6.372 8.512zm-1.42-4.49H7a1.09 1.09 0 1 1 0-2.18 1.09 1.09 0 0 1 0 2.18zm3.267-1.79h-.959a2.395 2.395 0 0 0-.181-.436l.679-.679a.234.234 0 0 0 0-.33l-.66-.66a.234.234 0 0 0-.33 0l-.679.679a2.395 2.395 0 0 0-.436-.181v-.96a.234.234 0 0 0-.234-.233h-.932a.234.234 0 0 0-.234.234v.959a2.396 2.396 0 0 0-.437.18l-.678-.678a.234.234 0 0 0-.33 0l-.66.66a.234.234 0 0 0 0 .33l.678.678c-.074.14-.135.286-.18.437h-.96a.234.234 0 0 0-.233.234v.933c0 .129.105.233.234.233h.958c.046.151.107.297.182.436l-.679.679a.234.234 0 0 0 0 .33l.66.66a.234.234 0 0 0 .33 0l.679-.679c.139.075.285.136.436.182v.959c0 .129.104.233.234.233h.932a.234.234 0 0 0 .234-.233v-.96c.151-.045.297-.106.437-.18l.678.678a.233.233 0 0 0 .33 0l.66-.66a.234.234 0 0 0 0-.33l-.679-.678c.075-.14.136-.286.181-.437h.96a.234.234 0 0 0 .233-.233v-.933a.233.233 0 0 0-.234-.234z",
    fill: "#C1D8EC",
    mask: "url(#os0cbs42cb)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimize);
export default __webpack_public_path__ + "static/media/optimize.11bfe3a3.svg";
export { ForwardRef as ReactComponent };